import * as React from 'react';
import moment from 'moment';

import { ICalendarState, IDay } from '../../classes/calendar';
import { connect } from 'react-redux';

import { ICalendarAppState } from '../../redux-state';
import { ICalendarAppText } from '../../redux-state/interfaces/text/calendar-app.text';
import GridMonthsView from './grid-months.view';
import { IEvent } from '../../interfaces/event';
import { IMonth } from '../../interfaces';

interface IGridMonthsExternalProps {
}

interface StateToProps {
    monthsData: IMonth<IEvent>[];
    nextmonthsData: IMonth<IEvent>[];
    text: ICalendarAppText;
}

export type GridMonthsProps = IGridMonthsExternalProps & StateToProps;

export class GridMonthsBase extends React.Component<GridMonthsProps, any> {
    render() {
        return (
            <GridMonthsView {...this.props} />
        )
    }
}

function mapStateToProps(state: ICalendarAppState, ownProps: IGridMonthsExternalProps): StateToProps {

    return {
        monthsData: state.calendar.filteredEvents,
        text: state.calendarText,
        nextmonthsData: state.calendar.filteredNextMonthEvents
    }
}

export default connect<StateToProps>(mapStateToProps)(GridMonthsBase);